import React, { useState, useCallback, useEffect, useMemo } from "react";
import { Modal, Tag, Input, Checkbox, Spin } from "antd";
import { debounce } from "lodash";
import moment from "moment";
import BUDGET_API from "../../../../../apis/budget.api";
export const AddRecurringPattren = ({
  title,
  open,
  handleCancel,
  handleChange,
  data,
  handleSave,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [patterns, setPatterns] = useState((data && data.patterns) || []);

  const [searchResults, setSearchResults] = useState([]);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalFoundTransactions, setTotalFoundTransactions] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputConfirm = () => {
    if (inputValue && !patterns.includes(inputValue)) {
      const updatedPatterns = [...patterns, inputValue];
      setPatterns(updatedPatterns);
      handleChange("patterns", updatedPatterns);
    }
    setInputValue("");
  };

  const handleTagClose = (removedTag) => {
    const updatedPatterns = patterns.filter((tag) => tag !== removedTag);
    setPatterns(updatedPatterns);
    handleChange("patterns", updatedPatterns);
  };
  const toggleTransactionSelection = (transaction) => {
    console.log("transaction", transaction);
    setSelectedTransactions((prevSelected) => {
      const isSelected = prevSelected.some((t) => t.id === transaction.id);
      if (isSelected) {
        return prevSelected.filter((t) => t.id !== transaction.id);
      } else {
        return [...prevSelected, transaction];
      }
    });
  };
  const searchPatternTransactions = useMemo(
    () =>
      debounce(async (query, page = 1, limit = 10) => {
        if (!query) {
          setSearchResults([]);
          return;
        }
        setLoading(true);
        try {
          let response = await BUDGET_API.searchRecurringAppliedTransaction(
            page,
            limit,
            query
          );
          if (response && response.data) {
            setSearchResults((prev) =>
              page === 1 ? response.data : [...prev, ...response.data]
            );
            setTotalPages(response.totalPages);
            setTotalFoundTransactions(response.total);
            setCurrentPage(page);
          } else {
            setTotalFoundTransactions(null);
            setTotalPages(1);
            setCurrentPage(1);
            setSearchResults([]);
            setSelectedTransactions([]);
          }
        } catch (error) {
          console.error("Error fetching transactions:", error);
        }
        setLoading(false);
      }, 500),
    []
  );
  useEffect(() => {
    searchPatternTransactions(inputValue, 1);
  }, [inputValue]);
  useEffect(() => {
    return () => {
      searchPatternTransactions.cancel();
    };
  }, []);
  const handleScroll = () => {
    const container = document.getElementById("transactions-search");
    if (!container) return;

    const { scrollTop, scrollHeight, clientHeight } = container;

    if (
      scrollTop + clientHeight >= scrollHeight - 10 &&
      !loadingMore &&
      currentPage < totalPages
    ) {
      setLoadingMore(true);
      searchPatternTransactions(inputValue, currentPage + 1);
      setLoadingMore(false);
    }
  };
  return (
    <div>
      {" "}
      <Modal
        visible={open}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <h3 className="modaltitle">{title}</h3>
        <div
          style={{
            marginTop: "1rem",
            maxHeight: "25rem",
            overflow: "scroll",
          }}
        >
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Token <span style={{ color: "red" }}>*</span>
            </h3>
            <input
              className="roleInput"
              placeholder="Token Name"
              name="token"
              value={data && data.token}
              id="token"
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
            />
          </div>
          {/* Patterns input */}
          <div style={{ marginTop: "1rem" }}>
            <h3 className="inputTitle">
              Patterns{" "}
              <span style={{ fontSize: "12px" }}>
                (Press enter to add Pattern)
              </span>
            </h3>
            {patterns &&
              patterns.map((pattern) => (
                <Tag
                  key={pattern}
                  closable
                  onClose={() => handleTagClose(pattern)}
                  style={{ marginBottom: "0.5rem" }}
                >
                  {pattern}
                </Tag>
              ))}
            <div className="addPatternButtonInput">
              <Input
                className="roleInput"
                placeholder="Enter pattern and press Enter"
                value={inputValue}
                onChange={handleInputChange}
                onPressEnter={handleInputConfirm}
              />
              <div
                className="addPatternButton"
                onClick={() => {
                  handleInputConfirm();
                }}
              >
                + Add
              </div>
            </div>
            {loading && <Spin />}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                {selectedTransactions &&
                  selectedTransactions.length > 0 &&
                  "Selected Transactions " + selectedTransactions.length}
              </div>
              <div>
                {totalFoundTransactions
                  ? "Total Transactions " + totalFoundTransactions
                  : null}
              </div>
            </div>
            {!searchResults ? (
              <Spin />
            ) : (
              <div
                className="searchResults"
                style={{ maxHeight: "10rem", overflowY: "auto" }}
                id="transactions-search"
                onScroll={handleScroll}
              >
                {searchResults.length > 0 ? (
                  searchResults.map((transaction) => (
                    <div
                      key={transaction.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px",
                        borderBottom: "1px solid #ddd",
                        cursor: "pointer",
                      }}
                      onClick={() => toggleTransactionSelection(transaction)}
                    >
                      <Checkbox
                        checked={selectedTransactions.some(
                          (t) => t.id === transaction.id
                        )}
                        onClick={(event) => event.stopPropagation()}
                        onChange={(event) => {
                          event.stopPropagation(); // Prevents the div's onClick from being triggered
                          toggleTransactionSelection(transaction);
                        }}
                        // onChange={() => toggleTransactionSelection(transaction)}
                      />
                      <span style={{ marginLeft: "1rem" }}>
                        {transaction.itemName}
                      </span>
                      <span style={{ marginLeft: "1rem" }}>
                        {transaction.date
                          ? moment(transaction.date).format("MM-DD-YYYY")
                          : "N/A"}
                      </span>
                    </div>
                  ))
                ) : (
                  <p style={{ color: "#aaa", textAlign: "center" }}>
                    No transactions found
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="buttonsMain">
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancel
          </button>
          <button
            className="savebutton"
            disabled={!data || !data.token}
            onClick={() => {
              handleSave(selectedTransactions);
            }}
          >
            Save
          </button>
        </div>
      </Modal>
    </div>
  );
};
